import { IS_DEBUG } from '@/client/confs/app';
import { RouteItem } from '@/client/confs/routes';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { matchRoute, Parser } from 'wouter';

export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};

export const getErrorMessage = (err: any) => {
  if (IS_DEBUG) console.error(err);
  return err?.shortMessage || err?.message;
};

export const findMatchingRoute = (routes: RouteItem[], parser: Parser, location: string, parent = ''): RouteItem | null => {
  for (const route of routes) {
    const path = parent + route.path;
    if (path === '*') return route;
    if (path === '/' ? path === location : matchRoute(parser, path, location)) {
      return route;
    }
    if (route.children && route.children?.length > 0) {
      const matchedChildRoute = findMatchingRoute(route.children, parser, location, path);
      if (matchedChildRoute) {
        return matchedChildRoute;
      }
    }
  }
  return null;
};
